import { xget, xhttp } from "../Fetchv2.js";
import { PGSchema } from "../schemas/pg.schema.js";

export class InterviewsAssigned {
	/**
	 * @param pgid - Page ID
	 * @param iid - Interview ID
	 * @param token - Token
	 * @param query - Query
	 * @path /pages/:pgid/interviews/:iid/assigned
	 */
	async getInterviewsAssigned(pgid: string, iid: string, token: string, query: { take?: number; skip?: number; name?: string }) {
		return xget<{ interviews_assigned: PGSchema.interviews_assigned[]; users: Pick<PGSchema.users, "id" | "name" | "last_name" | "dpi" | "email">[] }>(
			`/pages/${pgid}/interviews/${iid}/assigned`,
			query,
			{
				headers: { "app-token": token! }
			}
		);
	}

	async getInterviewsAssignedByUid(pgid: string, uid: string, token: string) {
		let rsp = await xget<{ interviews_assigned: PGSchema.interviews_assigned[]; interviews: PGSchema.interviews[] }>(
			`/pages/${pgid}/interviews-users/${uid}`,
			{},
			{ headers: { "app-token": token! } }
		);
		if (rsp.error) {
			console.error(rsp.error);
			return rsp;
		}
		rsp.json.interviews_assigned.forEach(i => {
			i.psm_interview = rsp.json.interviews.find(j => j.id == i.iid);
		});
		return rsp;
	}

	/**
	 * @path /pages/:pgid/interviews/:iid/assigned
	 * @param assigned: Partial<PGSchema.interviews_assigned>
	 */
	async createInterviewAssigned(pgid: string, iid: string, assigned: Partial<PGSchema.interviews_assigned>, token: string) {
		return xhttp<{ interview_assigned: PGSchema.interviews_assigned }>(`/pages/${pgid}/interviews/${iid}/assigned`, "POST", assigned, { headers: { "app-token": token! } });
	}

	/**
	 * @path /pages/:pgid/interviews/:iid/assigned/:id
	 * @param pgid - Page ID
	 * @param iid - Interview ID
	 * @param id - Interview Assigned ID
	 */
	async getInterviewAssigned(pgid: string, iid: string, id: string, token?: string) {
		return xget<{ interview_assigned: PGSchema.interviews_assigned; interview: PGSchema.interviews; skills: PGSchema.interview_skills[]; user?: PGSchema.users }>(
			`/pages/${pgid}/interviews/${iid}/assigned/${id}`,
			{},
			{ headers: { "app-token": token! } }
		);
	}

	/**
	 * @path /pages/:pgid/interviews/:iid/assigned/:id
	 * @param assigned: Partial<PGSchema.interviews_assigned>
	 */
	async updateInterviewAssigned(pgid: string, iid: string, id: string, assigned: Partial<PGSchema.interviews_assigned>, token?: string) {
		return xhttp<{ interview_assigned: PGSchema.interviews_assigned }>(`/pages/${pgid}/interviews/${iid}/assigned/${id}`, "PUT", assigned, { headers: { "app-token": token! } });
	}

	/**
	 * @path /pages/:pgid/interviews/:iid/assigned/:id
	 * @param id: string
	 */
	async deleteInterviewAssigned(pgid: string, iid: string, id: string, token: string) {
		return xhttp<{ interview_assigned: PGSchema.interviews_assigned }>(`/pages/${pgid}/interviews/${iid}/assigned/${id}`, "DELETE", {}, { headers: { "app-token": token! } });
	}
}
